import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      onlineSupport: {
        header: defineMessages({
          title: {
            id: 'pages.landing.onlineSupport.header.title',
            defaultMessage: 'Need help? Get Live Support.',
          },
          description: {
            id: 'pages.landing.onlineSupport.header.description',
            defaultMessage:
              'Need help or have questions? Chat with us below or check our <a>FAQ</a> for common answers.',
          },
        }),
      },
    },
  },
};
